import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import './UIElement.css'

interface UIElementProps {
  id: string
  type: 'textfield' | 'slider' | 'checkbox' | 'dropdown'
  isSelected: boolean
  onClick: () => void
  onDelete: () => void
  dragPosition: 'before' | 'after' | null
}

function UIElement({ id, type, isSelected, onClick, onDelete, dragPosition }: UIElementProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const getElementClassName = () => {
    const classes = ['ui-element', `ui-element-${type}`]
    if (isSelected) classes.push('selected')
    if (dragPosition === 'before') classes.push('drag-over-before')
    if (dragPosition === 'after') classes.push('drag-over-after')
    if (isDragging) classes.push('dragging')
    return classes.join(' ')
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={getElementClassName()}
      onClick={onClick}
    >
      {type === 'textfield' && (
        <div className="textfield-content">
          <div className="textfield-cursor"></div>
        </div>
      )}

      {type === 'slider' && (
        <div className="slider-content">
          <div className="slider-track"></div>
          <div className="slider-knob"></div>
        </div>
      )}

      {type === 'checkbox' && (
        <div className="checkbox-content">
          <div className="checkbox-box"></div>
          <div className="checkbox-label"></div>
        </div>
      )}

      {type === 'dropdown' && (
        <div className="dropdown-content">
          <div className="dropdown-arrow">▼</div>
        </div>
      )}

      {isSelected && (
        <button className="delete-button" onClick={(e) => {
          e.stopPropagation()
          onDelete()
        }}>
          ×
        </button>
      )}
    </div>
  )
}

export default UIElement
